// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type CreateDocumentCollectionMutationVariables = Types.Exact<{
  input: Types.CreateDocumentCollectionInput;
}>;


export type CreateDocumentCollectionMutation = { __typename?: 'Mutation', createDocumentCollection: { __typename?: 'DocumentCollection', id: string, name: string, description?: string | null, icon: Types.DocumentCollectionIcon, createdAt: any, updatedAt: any } };


export const CreateDocumentCollectionDocument = gql`
    mutation CreateDocumentCollection($input: CreateDocumentCollectionInput!) {
  createDocumentCollection(input: $input) {
    id
    name
    description
    icon
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateDocumentCollectionMutation__
 *
 * To run a mutation, you first call `useCreateDocumentCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentCollectionMutation, { data, loading, error }] = useCreateDocumentCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDocumentCollectionMutation, CreateDocumentCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentCollectionMutation, CreateDocumentCollectionMutationVariables>(CreateDocumentCollectionDocument, options);
      }
export type CreateDocumentCollectionMutationHookResult = ReturnType<typeof useCreateDocumentCollectionMutation>;
export type CreateDocumentCollectionMutationResult = ApolloReactCommon.MutationResult<CreateDocumentCollectionMutation>;